import moment from "moment";

export const APPOINTMENT_HOURS = Array.from({ length: 12 }, (_, index) =>
  String(index + 1).padStart(2, "0"),
);

export const APPOINTMENT_MINUTES = Array.from({ length: 60 }, (_, index) =>
  String(index).padStart(2, "0"),
);

export const APPOINTMENT_PERIODS = ["AM", "PM"];

export function parseAppointmentTimeParts(value) {
  const parsed = moment(
    String(value || "").trim(),
    ["hh:mm A", "h:mm A", "HH:mm", "hh:mm a", "h:mm a"],
    true,
  );
  if (!parsed.isValid()) {
    return { hour: "", minute: "", period: "AM" };
  }
  return {
    hour: parsed.format("hh"),
    minute: parsed.format("mm"),
    period: parsed.format("A"),
  };
}

export function composeAppointmentTime(hour, minute, period) {
  if (!hour || minute === "" || minute == null || !period) return "";
  const parsed = moment(
    `2000-01-01 ${hour}:${minute} ${period}`,
    "YYYY-MM-DD hh:mm A",
    true,
  );
  return parsed.isValid() ? parsed.format("hh:mm A") : "";
}

/** True when date+time is strictly before the current minute. */
export function isAppointmentDateTimePast(date, hour, minute, period) {
  if (!date || !hour || minute === "" || minute == null || !period) {
    return false;
  }
  const composed = composeAppointmentTime(hour, minute, period);
  if (!composed) return false;
  const selected = moment(
    `${moment(date).format("YYYY-MM-DD")} ${composed}`,
    "YYYY-MM-DD hh:mm A",
    true,
  );
  return selected.isValid() && selected.isBefore(moment(), "minute");
}

export function isAppointmentTimeValuePast(date, timeValue) {
  const parts = parseAppointmentTimeParts(timeValue);
  return isAppointmentDateTimePast(
    date,
    parts.hour,
    parts.minute,
    parts.period,
  );
}

export function isAppointmentHourSelectable(date, hour, period) {
  if (!date || !hour || !period) return true;
  if (!moment(date).isSame(moment(), "day")) return true;
  return APPOINTMENT_MINUTES.some(
    (minute) => !isAppointmentDateTimePast(date, hour, minute, period),
  );
}

export function isAppointmentMinuteSelectable(date, hour, minute, period) {
  if (!date || !hour || minute === "" || minute == null || !period) return true;
  if (!moment(date).isSame(moment(), "day")) return true;
  return !isAppointmentDateTimePast(date, hour, minute, period);
}

export function isAppointmentPeriodSelectable(date, period) {
  if (!date || !period) return true;
  if (!moment(date).isSame(moment(), "day")) return true;
  return APPOINTMENT_HOURS.some((hour) =>
    isAppointmentHourSelectable(date, hour, period),
  );
}
